<template>
  <div class="container">
    <div class="card card-container p-4">
    <h3>Logowanie użytkownika</h3>
      <form name="form" @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="username">Nazwa użytkownika</label>
          <input v-model="user.name" type="text" class="form-control" name="username" />
          <div class="alert alert-danger" role="alert" v-if="errors['name']">
            Nazwa użytkownika jest wymagane
          </div>
        </div>
        <div class="form-group">
          <label for="password">Hasło</label>
          <input v-model="user.password" type="password" class="form-control" name="password" />
          <div class="alert alert-danger" role="alert" v-if="errors['password']">
            Hasło jest wymagane!
          </div>
        </div>
        
        <div class="form-group text-center">
          <button class="btn btn-primary" :disabled="loading">
            <span v-show="loading" class="spinner-border spinner-border-sm"></span>
            <span>Zaloguj się</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import User from '../../models/User';
import store from '../../_configuration/store/index';
import toastr from '../../mixins/toastr';
import urlConfig from '../../mixins/url';

export default {
  name: 'Login',
  mixins: [toastr],
  data() {
    return {
      user: new User('', ''),
      loading: false,
      message: '',
      errors: {},
    };
  },
  mounted() {
    if (store.getters.isLoggedIn) {
      this.$router.push('/');
    }
  },
  methods: {
    validateForm() {
      this.errors = {};
      if (!this.user.password) {
        this.errors.password = true;
      }
      if (!this.user.name) {
        this.errors.name = true;
      }
    },
    handleLogin() {
      var that = this;
      this.validateForm();
      var errorCount = Object.keys(this.errors).length;
      if (errorCount == 0) {
        this.loading = true;
        if (this.user.name && this.user.password) {
          var loginUrl = urlConfig.data().url.serverUrl + urlConfig.data().url.Auth.Login;
          axios({ url: loginUrl, data: this.user, method: 'POST' })
            .then((resp) => {
              const token = resp.data.token;
              //const user = resp.data.userName;
              that.$store.commit('setToken', token);
              that.$router.push('/');
              that.loading = false;
            })
            .catch((  ) => {
              localStorage.removeItem('token');
              that.DisplayError('Błąd podczas logowania', 'Wystąpił błąd w komunikacji z serwerem');
              that.loading = false;
            });
        }
      }
    },
  },
};
</script>
